import type { paths } from '../../types/yakubato-lp-api';
import { request, type OpenApiFetchClient } from './types';

export type GetTop200Response =
  paths['/top']['get']['responses']['200']['content']['application/json'];

export function createTopApi(client: OpenApiFetchClient) {
  return {
    getTop() {
      return request<GetTop200Response>(client.GET('/top'));
    },
  };
}
